export default [
  {
    path: '/ai-scenarios',
    component: () => import('./views/Index'),
    name: 'ai_scenario',
    redirect: { name: 'ai_scenario-list' },
    children: [
      {
        path: '',
        name: 'ai_scenario-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'content',
        },
      },
      {
        path: ':id',
        name: 'ai_scenario-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'content',
        },
      },
    ],
  },
]
